export interface Article {
  id: string;
  title: string;
  category: string;
  date: string;
  readTime: string;
  excerpt: string;
  cover: string;
  content: string[];
  color: string;
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '韩国免费漫画怎么找？六个靠谱入口帮你理清思路',
    category: '新手入门',
    date: '2026.08.18',
    readTime: '6 分钟',
    excerpt: '很多刚入坑的朋友都在问"韩国免费漫画哪里看最全"。这篇指南从网站、APP、网页端三个维度，帮你把靠谱的资源渠道一次理清。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20laptop%20and%20smartphone%20displaying%20colorful%20comic%20panels%20on%20a%20dark%20desk%2C%20warm%20coral%20and%20amber%20lighting%2C%20clean%20modern%20guide%20style%2C%20vibrant%20digital%20art&width=800&height=500&seq=article-a1&orientation=landscape',
    color: '#ff5f2e',
    content: [
      '刚接触韩国免费漫画的朋友，最容易踩的坑就是在搜索引擎里乱翻，点进去要么广告满天飞，要么资源东拼西凑。其实只要认准几条核心路径，找起来并不复杂。',
      '第一类入口是聚合型漫画网站。这类站点把大量韩漫连载和完结作品集中收录，通常在首页就能看到"日更""热榜"等栏目，搜索和分类都做得比较完善，是日常追更的首选。判断标准很简单：更新是否稳定、是否有清晰的作品目录。',
      '第二类入口是专门的韩漫APP。相比网页端，APP的优势在于缓存离线、追更提醒和多源切换，手机党用起来更顺手。挑选时可以重点关注它是否支持无遮拦高清，以及更新速度是否跟得上连载。',
      '第三类入口是网页端免下载资源。适合临时想看、又不想安装应用的朋友，浏览器打开即看，省去下载步骤。这类入口胜在轻量，但功能相对单一。',
      '总结一下：追更选聚合网站，手机党选APP，临时看选网页端。把这三种渠道搭配使用，基本就能覆盖九成以上的韩国免费漫画阅读需求了。',
    ],
  },
  {
    id: 'a2',
    title: '2026 韩漫人气榜：这些作品正在被全网追更',
    category: '热门推荐',
    date: '2026.08.15',
    readTime: '5 分钟',
    excerpt: '从宫廷逆袭到都市甜宠，从热血奇幻到治愈美食，这份人气榜单整理了近期被追更最多的韩漫代表作，按口味对号入座。',
    cover: 'https://readdy.ai/api/search-image?query=energetic%20illustration%20of%20a%20trophy%20and%20ranking%20podium%20with%20comic%20book%20covers%20floating%20around%2C%20warm%20coral%20and%20gold%20colors%2C%20vibrant%20celebratory%20digital%20art%2C%20clean%20composition&width=800&height=500&seq=article-a2&orientation=landscape',
    color: '#f2c94c',
    content: [
      '最近一段时间，韩国免费漫画圈里讨论度最高的，几乎都集中在几个固定类型上。如果你还在纠结下一部看什么，不妨从这份人气榜里挑。',
      '宫廷逆袭类依然是流量担当。女主从底层逆袭、手撕仇敌的爽快叙事，配合精细的画面表现，追更体验极佳。这类作品节奏快、爽点密集，特别适合入坑。',
      '都市甜宠和欢喜冤家类则满足了大家对轻松爱情的期待，剧情温暖治愈，适合在疲惫的日常里放松心情，也是很多读者的"下饭"首选。',
      '热血奇幻与战斗类保持稳定热度，世界观宏大、战斗场面震撼，追求视觉冲击的读者几乎不会失望。',
      '此外，治愈美食、校园纯爱等细分类型也在快速升温。这些作品画风清新、情绪细腻，正在吸引越来越多新读者加入追更大军。',
    ],
  },
  {
    id: 'a3',
    title: '无遮拦与有遮拦到底差在哪？读韩漫前先弄清这几点',
    category: '阅读科普',
    date: '2026.08.12',
    readTime: '4 分钟',
    excerpt: '"无遮拦"是韩国漫画阅读里常被提起的词。它到底是什么、为什么有人执着于无遮拦，这篇帮你把概念彻底讲透。',
    cover: 'https://readdy.ai/api/search-image?query=minimal%20illustration%20of%20an%20open%20comic%20book%20with%20glowing%20light%20rays%20in%20a%20dark%20room%2C%20warm%20amber%20and%20coral%20tones%2C%20clean%20conceptual%20digital%20art%2C%20soft%20atmosphere&width=800&height=500&seq=article-a3&orientation=landscape',
    color: '#7bab97',
    content: [
      '在很多韩国免费漫画网站的说明里，都能看到"无遮拦"三个字。它指的是阅读版本不进行画面遮挡或打码处理，最大程度保留原作内容。',
      '之所以会有"遮拦"版本，主要与内容审核与分级机制有关。部分平台在展示某些画面时，会出于规则要求做局部处理，而"无遮拦"版本则还原了原始画面。',
      '对于追求原汁原味阅读体验的读者来说，无遮拦版本自然更受欢迎。但需要提醒的是，无遮拦内容适合成年读者，请根据自身情况理性选择。',
      '选择资源时，如果页面明确标注"无遮拦""原版"，通常意味着保留了完整内容；反之则可能在关键画面做了处理。了解这个差异，能帮你更精准地找到想要看的版本。',
    ],
  },
  {
    id: 'a4',
    title: '韩漫APP挑选攻略：六个维度帮你选到顺手的追更工具',
    category: '工具评测',
    date: '2026.08.09',
    readTime: '7 分钟',
    excerpt: '市面上的韩漫APP五花八门，哪个才是真正好用的？从画质、更新、稳定性、广告、缓存、多源六个维度，给你一份实在的挑选参考。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20hand%20holding%20a%20phone%20with%20six%20floating%20rating%20badges%20around%20it%2C%20warm%20coral%20and%20amber%20palette%2C%20clean%20modern%20review%20style%2C%20vibrant%20digital%20art&width=800&height=500&seq=article-a4&orientation=landscape',
    color: '#ff9a73',
    content: [
      '选择韩漫APP时，很多人只看下载量，其实更要看的是实际体验。这里给你一套六个维度的挑选框架，帮你少走弯路。',
      '第一看画质。是否支持高清与无遮拦原版，直接决定了阅读观感。第二看更新速度，连载同步越快的APP，追更越不心累。',
      '第三看稳定性。频繁闪退、加载卡顿的APP，再好的资源也白搭。第四看广告体验，弹窗和全屏广告会严重打断阅读节奏。',
      '第五看缓存与离线功能。通勤、无网络环境下能否顺畅阅读，是很多重度读者的核心诉求。第六看多源支持，能聚合多个资源站的APP，内容覆盖更广，出现断更的概率更低。',
      '把这六个维度列成一张表，逐项对比下来，哪款更值得长期使用就一目了然了。',
    ],
  },
  {
    id: 'a5',
    title: '追更必知：韩漫"日更"机制与更新时间全解析',
    category: '阅读科普',
    date: '2026.08.05',
    readTime: '5 分钟',
    excerpt: '为什么有的韩漫天天更，有的却周更？搞懂韩漫的更新机制，能让你更合理地安排追更节奏，不错过任何一话。',
    cover: 'https://readdy.ai/api/search-image?query=illustration%20of%20a%20calendar%20with%20glowing%20update%20notification%20dots%20and%20comic%20panels%2C%20warm%20coral%20and%20gold%20colors%2C%20clean%20modern%20digital%20art%2C%20organized%20composition&width=800&height=500&seq=article-a5&orientation=landscape',
    color: '#f5d66b',
    content: [
      '"日更"是韩国免费漫画阅读里出现频率最高的词之一，指的是作品每天都会更新新内容。但并非所有韩漫都是日更，了解背后的更新机制很有必要。',
      '大多数在连载中的热门韩漫，会按照每周固定的节奏更新，比如每周更新一到两话，更新时间通常集中在晚间。',
      '而标注"日更"的作品，往往是聚合站点将多个作品的更新集中整合，让读者每天都能看到新内容。这种日更体验，让追更更有连续性。',
      '部分完结作品则会一次性放出全部内容，即"全集在线"，适合喜欢一口气看完的读者，完全不用等更新。',
      '合理利用"日更""周更""全集"三种节奏，再结合更新日历功能，你就能轻松掌控自己的追更计划了。',
    ],
  },
  {
    id: 'a6',
    title: '韩漫常见题材扫盲：言情、奇幻、爽文一次看懂',
    category: '新手入门',
    date: '2026.07.28',
    readTime: '6 分钟',
    excerpt: '宫廷逆袭、穿书沙雕、重生爽文……韩漫题材名目繁多，新手容易看花眼。这篇给你按类别梳理，帮你快速找到自己爱的类型。',
    cover: 'https://readdy.ai/api/search-image?query=colorful%20illustration%20of%20many%20comic%20book%20genres%20fanning%20out%20with%20distinct%20theme%20icons%2C%20warm%20coral%20amber%20and%20teal%20palette%2C%20clean%20educational%20digital%20art%2C%20vibrant%20composition&width=800&height=500&seq=article-a6&orientation=landscape',
    color: '#93c0ac',
    content: [
      '韩漫的题材体系非常丰富，对于刚入门的新手来说，先搞清常见的几大类，能帮你更快找到对味的作品。',
      '言情恋爱类是绝对主力，涵盖宫廷、都市、校园等多个场景，主打细腻的感情线与人设。',
      '奇幻玄幻类拥有宏大的世界观与战斗场面，适合喜欢冒险与想象力的读者。热血战斗类则更聚焦打斗与成长。',
      '穿书与重生类近年热度极高，核心是"反套路"的爽感叙事，剧情往往意想不到，特别适合追求新鲜感的读者。',
      '此外还有治愈美食、悬疑惊悚、都市职场等细分类型。摸清自己的口味偏好，再去对应的分类里挑选，就能事半功倍。',
    ],
  },
];

export const articleCategories = ['全部', '新手入门', '热门推荐', '阅读科普', '工具评测'];